import { reportError } from '@app/core/integrations/bugsnag';
import { useCreatedReport } from '@app/modules/audit/modules/global-audit/hooks/useCreatedReport';
import { auditReports } from '@mi-front/api-clients';
import { useQueryClient } from '@tanstack/react-query';
import { ReportExportApi } from './report-export-api';

export function useGipAltExportApi(): ReportExportApi {
  const queryClient = useQueryClient();

  const exportMutation = auditReports.useEvidenceExportGipAltReport({
    mutation: {
      onSuccess: (_data, variables) => {
        if (variables?.id) {
          queryClient.invalidateQueries({
            queryKey: useCreatedReport.queryKey(variables.id),
          });
        }
      },
      onError: (error: any) => {
        reportError(error);
      },
    },
  });

  return {
    exportReport: async (id: string, options: unknown) => {
      await exportMutation.mutateAsync({
        id,
        data: options as auditReports.GipEvidenceExportOptionsDto,
      });
    },
    useExportStatus: (id: string, enabled: boolean) =>
      auditReports.useGetGipAltReportExportStatus(id || '', {
        query: {
          enabled,
          refetchInterval: (query) => {
            const status = (query.state.data as auditReports.PublicJobDto | undefined)?.status;
            return status === auditReports.PublicJobDtoStatusEnum.IN_PROGRESS ? 1000 : false;
          },
        },
      }),
    useExportUrl: (id: string, enabled: boolean) =>
      auditReports.useGetGipAltReportEvidenceExportUrl1(id, {
        query: {
          enabled,
        },
      }),
  };
}
